<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="房号" prop="fangno">
                <el-input
                    v-model="queryParams.fangno"
                    placeholder="请输入房号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>


        <el-table v-loading="loading" :data="shuidianList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="房型" align="center" prop="fangxing"/>
            <el-table-column label="房号" align="center" prop="fangno"/>
            <!--      <el-table-column label="openid" align="center" prop="openId" />-->
            <el-table-column label="用户姓名" align="center" prop="userName"/>
            <el-table-column label="初始水表数据" align="center" prop="chuShui"/>
            <el-table-column label="更新水表数据" align="center" prop="shuiInfo"/>
            <el-table-column label="水费(元)" align="center" prop="shui">
                <template slot-scope="scope">
                    <!--          <label>{{ scope.row.shui / 100 }}</label>-->
                    <label style="color: #F56C6C" v-if="scope.row.shui / 100<0">{{ (scope.row.shui / 100).toFixed(3) }}元</label>
                    <label style="color: #67C23A" v-if="scope.row.shui / 100>=0">{{ (scope.row.shui / 100).toFixed(3) }}元</label>

                </template>
            </el-table-column>
            <!--      <el-table-column label="初始电表度数" align="center" prop="chuDian"/>-->
            <!--      <el-table-column label="更新电表度数" align="center" prop="dianInfo"/>-->
            <!--      <el-table-column label="电费(元)" align="center" prop="dian">-->
            <!--        <template slot-scope="scope">-->
            <!--          &lt;!&ndash;          <label>{{ scope.row.shui / 100 }}</label>&ndash;&gt;-->
            <!--          <label style="color: #F56C6C" v-if="scope.row.dian / 100<0">{{ (scope.row.dian / 100).toFixed(3) }}元</label>-->
            <!--          <label style="color: #67C23A" v-if="scope.row.dian / 100>=0">{{ (scope.row.dian / 100).toFixed(3) }}元</label>-->

            <!--        </template>-->
            <!--      </el-table-column>-->
            <!--      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">-->
            <!--        <template slot-scope="scope">-->
            <!--          <el-button-->
            <!--            size="mini"-->
            <!--            type="text"-->
            <!--            icon="el-icon-edit"-->
            <!--            @click="handleUpdate(scope.row)"-->
            <!--          >扣减费用-->
            <!--          </el-button>-->
            <!--        </template>-->
            <!--      </el-table-column>-->

        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改水电费管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="初始水表数据">
                    <el-input v-model="form.chuShui" placeholder="请输入初始水表数据"/>
                </el-form-item>
                <el-form-item label="水费余额">

                    <label>{{ (form.shuiyue / 100).toFixed(3) }}</label>
                </el-form-item>
                <el-form-item label="更新水表数据">
                    <el-input v-model="form.shuiInfo" placeholder="请输入更新水表数据"/>
                </el-form-item>
                <!--        <el-form-item label="扣减水费(元)">-->
                <!--          <el-input v-model="form.shui" placeholder="请输入扣减水费(元)"/>-->
                <!--        </el-form-item>-->
                <br>
                <br>
                <el-form-item label="初始电表数据">
                    <el-input v-model="form.chuDian" placeholder="请输入初始电表数据"/>
                </el-form-item>
                <el-form-item label="电费余额">

                    <label>{{ (form.dianyue / 100).toFixed(3) }}</label>
                </el-form-item>
                <el-form-item label="更新电表数据">
                    <el-input v-model="form.dianInfo" placeholder="请输入更新电表数据"/>
                </el-form-item>
                <!--        <el-form-item label="扣减电费(元)">-->
                <!--          <el-input v-model="form.dian" placeholder="请输入扣减电费(元)"/>-->
                <!--        </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getShuidian, delShuidian, addShuidian, updateShuidian, shuiqian} from "@/api/homestay/api";

export default {
    name: "shuiqian",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 水电费管理表格数据
            shuidianList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                fangno: null,
                openId: null,
                userName: null,
                shui: null,
                chuShui: null,
                chuDian: null,
                dian: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                fangInfoId: [
                    {required: true, message: "房间id不能为空", trigger: "blur"}
                ],
                openId: [
                    {required: true, message: "openid不能为空", trigger: "blur"}
                ],
                userName: [
                    {required: true, message: "用户姓名不能为空", trigger: "blur"}
                ],
                shui: [
                    {required: true, message: "水费(分)不能为空", trigger: "blur"}
                ],
                dian: [
                    {required: true, message: "电费(分)不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询水电费管理列表 */
        getList() {
            this.loading = true;
            // var pageNum = this.queryParams.pageNum;
            // var pageSize = this.queryParams.pageSize;
            // var fangno = this.queryParams.fangno;
            // {'pageNum':pageNum, 'pageSize': pageSize, 'fangno': fangno}
            // console.log('pageNum:' + pageNum + 'pageSize:' + pageSize);
            shuiqian(this.queryParams).then(response => {
                this.shuidianList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                fangInfoId: null,
                openId: null,
                userName: null,
                shui: null,
                shuiyue: null,
                chuShui: null,
                chuDian: null,
                shuiInfo: null,
                dian: null,
                dianyue: null,
                dianInfo: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加水电费管理";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const id = row.id || this.ids
            getShuidian(id).then(response => {
                this.form.id = row.id || this.ids;
                this.form.chuShui = response.data.chuShui
                this.form.chuDian = response.data.chuDian
                this.form.shuiInfo = response.data.shuiInfo
                this.form.dianInfo = response.data.dianInfo
                this.form.shuiyue = response.data.shui
                this.form.dianyue = response.data.dian
                this.open = true;
                this.title = "扣减水电费";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        this.form.shui = this.form.shui * 100
                        this.form.dian = this.form.dian * 100
                        updateShuidian(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addShuidian(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids;
            this.$modal.confirm('是否确认删除水电费管理编号为"' + ids + '"的数据项？').then(function () {
                return delShuidian(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
    }
};
</script>
